import PropTypes from 'prop-types';
import { useEffect } from 'react';
import $ from 'jquery';
import 'select2';
import 'select2/dist/css/select2.css';
import FontAwesomeSingleSelection from '../../../utils/select2-custom';
import { useMeasuringPointsQuery } from './utils';

function formatOption(option) {
    if (!option.id) {
        return option.text;
    }
    const swarmType = option.element.attributes.swarm_type.value;
    const detached = option.element.attributes.detached.value === 'true';

    return $(`
        <span class="flex items-center">
            <div class="swarm-${swarmType}-icon ${
        detached ? 'detached-device' : ''
    } mr-1.5 h-6 w-8"></div>
            ${option.text}
        </span>
    `);
}

function getMpDisplayName(measuringPoint) {
    const { name, project, deviceName } = measuringPoint;
    let displayName = name;
    if (project) {
        displayName = `${project} - ${name}`;
    }
    if (deviceName) {
        displayName += ` (${deviceName})`;
    }
    return displayName;
}

// TODO:Remove the usage of jQuery.
// https://github.com/omnidots/website/issues/7770
const MeasuringPointSelect = ({
    selectId,
    onSelectChange,
    onReady,
    initialValue,
    allowNoSelection = false,
    noSelectionText = gettext('SELECT_MEASURING_POINT'),
    className = 'shadow-select',
    ...props
}) => {
    const { measuringPoints, loading } = useMeasuringPointsQuery();

    useEffect(() => {
        const selectElement = $(`#${selectId}`);
        selectElement.select2({
            width: '100%',
            selectionAdapter: FontAwesomeSingleSelection,
            theme: 'default select2-search',
            templateResult: formatOption,
            templateSelection: formatOption,
        });

        selectElement.on('select2:select', (e) => {
            onSelectChange(e.currentTarget.value);
        });

        // Cleanup on unmount.
        return () => {
            selectElement.off('select2:select');
            selectElement.select2('destroy');
        };
    }, [selectId, onSelectChange]);

    useEffect(() => {
        if (!loading && onReady) {
            onReady();
        }
    }, [loading, onReady]);

    return (
        <div className={className}>
            <select
                id={selectId}
                aria-label={gettext('SELECT_MEASURING_POINT')}
                {...(initialValue && { value: initialValue })}
                {...props}
            >
                {allowNoSelection && <option value="">{noSelectionText}</option>}
                {measuringPoints.map((measuringPoint, index) => (
                    <option
                        key={index}
                        value={measuringPoint.id}
                        device_name={measuringPoint.deviceName}
                        // eslint-disable-next-line react/no-unknown-property
                        detached={(measuringPoint.deviceName === null).toString()}
                        // eslint-disable-next-line react/no-unknown-property
                        swarm_type={measuringPoint.__typename
                            .split('MeasuringPoint')[0]
                            .toLowerCase()}
                        // eslint-disable-next-line react/no-unknown-property
                        permission={measuringPoint.permission}
                    >
                        {getMpDisplayName(measuringPoint)}
                    </option>
                ))}
            </select>
        </div>
    );
};
MeasuringPointSelect.propTypes = {
    selectId: PropTypes.string.isRequired,
    onSelectChange: PropTypes.func.isRequired,
    onReady: PropTypes.func,
    initialValue: PropTypes.string,
    allowNoSelection: PropTypes.bool,
    noSelectionText: PropTypes.string,
    className: PropTypes.string,
};

export default MeasuringPointSelect;
